export const DEFAULT_SLIDER_COLOR = '#009AFA';
